export const Paths = {
  notifications: '/notifications',
  notificationsAll: '/notifications/all',
  notificationsUnread: '/notifications/unread',
  messages: '/messages',
  favourites: '/favourites',
  ratings: '/ratings',
  likedPosts: '/liked-posts',
  myTickets: '/my-tickets',
  myTicket: '/my-tickets/:kind/:id',
}
